import {Subject} from 'rxjs';

import IInteractionPayload from '../../../Analytics/Interactions/Interfaces/IInteractionPayload';
import StoreName           from '../../Shared/Constants/StoreName';
import IPlayerState        from '../../Shared/Interfaces/IPlayerState';

import createVolumeActionsResolver from './createVolumeActionsResolver';
import IVolume                     from './Interfaces/IVolume';
import IVolumeStore                from './Interfaces/IVolumeStore';
import Volume                      from './Volume';

const createVolumeStore = (
    state: IPlayerState,
    interactions$: Subject<IInteractionPayload>,
    initialValue: IVolume = {}
): IVolumeStore => {
    const resolveVolumeActions = createVolumeActionsResolver(interactions$);

    return state.createStore({
        name: StoreName.VOLUME,
        model: Volume,
        actions: resolveVolumeActions
    }, initialValue);
};

export default createVolumeStore;
